import constant from '../../const.js';

const state = {
    step: 1,

    quotations_updated: false,

    request: {
        company_id: null, // Only used for admin accounts

        cargo_ready_date: constant.getDate(0),
        schedule_horizon: constant.MINIMUM_HORIZON_WEEKS,
        quotation_type: constant.QUOTATION_TYPE_SEA_FCL,

        origin_port: {},
        destination_port: {},

        cargo_type: {
            code: 'NON-DG',
            label: 'Non dangerous goods'
        },
        commodity: null,
        //container_load: 'FCL',
        transaction_type: 'EXPORT',
        currency: 'MYR',
        incoterm: {},
        hs_code: null,

        include_customs_clearance_export: false,
        include_customs_clearance_import: false,

        // FCL components
        containers: [
          {
            container_quantity: 1,
            container_size: "20",
            container_type: "DRY"
          }
        ],

        container_total: 0,
        include_haulage_export: false,
        include_haulage_sdl_export: false,
        city_haulage_export: {},
        include_haulage_import: false,
        include_haulage_sdl_import: false,
        city_haulage_import: {},

        // LCL components
        packing_quantity: 1,
        packing_type: 'pallet',
        total_weight: 100,
        weight_unit: 'kg',
        total_cubic_meters: 1,

        // LCL components deprecated
        cargo_units: [{
            // height: 1,
            // width: 1,
            // length: 1,
            total_cubic_meters: 1,
            total_weight: 100,
            // dimension_unit: 'm',
            // weight: 100,
            weight_unit: 'kg',
            quantity: 1,
            type: 'pallet'
        }],
        include_transport_export: false,
        city_transport_export: {},
        include_transport_import: false,
        city_transport_import: {},

        include_telex_release: true,
        include_other_services: false,
        other_services: null,
        include_letter_of_credit_handling: false,

        //Insurance values
        include_insurance: false,
        cargo_value: null,
        cargo_value_currency: 'USD'
    }
};

const mutations = {
    reset(state) {
        state.step = 1;
        state.quotations_updated = false;

        state.request = {
            company_id: null, // Only used for admin accounts

            cargo_ready_date: constant.getDate(0),
            schedule_horizon: constant.MINIMUM_HORIZON_WEEKS,

            origin_port: {},
            destination_port: {},

            cargo_type: {
                code: 'NON-DG',
                label: 'Non dangerous goods'
            },
            commodity: null,
            quotation_type: constant.QUOTATION_TYPE_SEA_FCL,
            //container_load: 'FCL',
            transaction_type: 'EXPORT',
            currency: 'MYR',
            incoterm: {},
            hs_code: null,

            include_customs_clearance_export: false,
            include_customs_clearance_import: false,

            // FCL components
            containers: [
                {
                    container_quantity: 1,
                    container_size: "20",
                    container_type: "DRY"
                }
            ],

            container_total: 0,
            include_haulage_export: false,
            include_haulage_sdl_export: false,
            city_haulage_export: {},
            include_haulage_import: false,
            include_haulage_sdl_import: false,
            city_haulage_import: {},

            // LCL components
            packing_quantity: 1,
            packing_type: 'pallet',
            total_weight: 100,
            weight_unit: 'kg',
            total_cubic_meters: 1,

            // LCL components deprecated
            cargo_units: [{
                // height: 1,
                // width: 1,
                // length: 1,
                // dimension_unit: 'm',
                total_cubic_meters: 1,
                // weight: 100,
                total_weight: 100,
                weight_unit: 'kg',
                quantity: 1,
                type: 'pallet'
            }],
            include_transport_export: false,
            city_transport_export: {},
            include_transport_import: false,
            city_transport_import: {},

            include_telex_release: true,
            include_other_services: false,
            other_services: null,
            include_letter_of_credit_handling: false,

            //Insurance values
            include_insurance: false,
            cargo_value: null,
            cargo_value_currency: 'USD'
        };
    },

    setStep(state, step) {
        state.step = step;
    },

    setQuotationsUpdated(state, quotations_updated) {
        state.quotations_updated = quotations_updated;
    },

    setCompanyID(state, company_id) {
        state.request.company_id = company_id;
    },

    setCurrency(state, currency) {
        state.request.currency = currency;
    },

    setCargoValue(state, cargo_value) {
        state.request.cargo_value = cargo_value;
    },

    setCargoValueCurrency(state, cargo_value_currency) {
        state.request.cargo_value_currency = cargo_value_currency;
    },

    setHSCode(state, hs_code) {
        state.request.hs_code = hs_code;
    },

    setScheduleHorizon(state, schedule_horizon) {
        state.request.schedule_horizon = schedule_horizon;
    },

    setCargoReadyDate(state, cargo_ready_date) {
        state.request.cargo_ready_date = cargo_ready_date;
    },

    setDestinationPort(state, destination_port) {
        state.request.destination_port = destination_port;
    },

    setOriginPort(state, origin_port) {
        state.request.origin_port = origin_port;
    },

    setCommodity(state, commodity) {
        state.request.commodity = commodity;
    },

    setCargoType(state, cargo_type) {
        state.request.cargo_type = cargo_type;
    },

    setQuotationType(state, quotation_type) {
        state.request.quotation_type = quotation_type;
    },

    // setContainerLoad(state, container_load) {
    //     state.request.container_load = container_load;
    // },

    setTransactionType(state, transaction_type) {
        state.request.transaction_type = transaction_type;
    },

    setIncoterm(state, incoterm) {
        state.request.incoterm = incoterm;
    },

    setContainerType(state, container_type) {
        state.request.container_type = container_type;
    },

    setContainerSize(state, container_size) {
        state.request.container_size = container_size;
    },

    setContainerQuantity(state, container_quantity) {
        state.request.container_quantity = container_quantity;
    },

    setCargoUnits(state, cargo_units) {
        state.request.cargo_units = cargo_units;
    },

    addCargoUnit(state) {
        state.request.cargo_units.push({
            total_cubic_meters: 1,
            total_weight: 100,
            weight_unit: 'kg',
            quantity: 1,
            type: 'pallet'
        });
    },

    deleteCargoUnit(state, cargo_unit) {
        state.request.cargo_units = state.request.cargo_units.filter(function (ele) {
            return ele != cargo_unit;
        });
    },

    setPackingQuantity(state, packing_quantity) {
        state.request.packing_quantity = packing_quantity;
    },

    setPackingType(state, packing_type) {
        state.request.packing_type = packing_type;
    },

    setTotalWeight(state, total_weight) {
        state.request.total_weight = total_weight;
    },

    setWeightUnit(state, weight_unit) {
        state.request.weight_unit = weight_unit;
    },

    setTotalCubicMeters(state, total_cubic_meters) {
        state.request.total_cubic_meters = total_cubic_meters;
    },

    setIncludeExportCustomsClearance(state, include_customs_clearance_export) {
        state.request.include_customs_clearance_export = include_customs_clearance_export;
    },

    setIncludeImportCustomsClearance(state, include_customs_clearance_import) {
        state.request.include_customs_clearance_import = include_customs_clearance_import;
    },

    setIncludeHaulageExport(state, include_haulage_export) {
        state.request.include_haulage_export = include_haulage_export;

        // if include haulage export is false, then include side loader becomes false
        if (!include_haulage_export) {
            state.request.include_haulage_sdl_export = false;
        }
    },

    setIncludeHaulageSDLExport(state, include_haulage_sdl_export) {
        state.request.include_haulage_sdl_export = include_haulage_sdl_export;
    },

    setCityHaulageExport(state, city_haulage_export) {
        state.request.city_haulage_export = city_haulage_export;
    },

    setIncludeHaulageImport(state, include_haulage_import) {
        state.request.include_haulage_import = include_haulage_import;

        // if include haulage import is false, then include side loader becomes false
        if (!include_haulage_import) {
            state.request.include_haulage_sdl_import = false;
        }
    },

    setIncludeHaulageSDLImport(state, include_haulage_sdl_import) {
        state.request.include_haulage_sdl_import = include_haulage_sdl_import;
    },

    setCityHaulageImport(state, city_haulage_import) {
        state.request.city_haulage_import = city_haulage_import;
    },

    setIncludeTransportExport(state, include_transport_export) {
        state.request.include_transport_export = include_transport_export;
    },

    setCityTransportExport(state, city_transport_export) {
        state.request.city_transport_export = city_transport_export;
    },

    setIncludeTransportImport(state, include_transport_import) {
        state.request.include_transport_import = include_transport_import;
    },

    setCityTransportImport(state, city_transport_import) {
        state.request.city_transport_import = city_transport_import;
    },

    setIncludeInsurance(state, include_insurance) {
        state.request.include_insurance = include_insurance;
    },

    setIncludeTelexRelease(state, include_telex_release) {
        state.request.include_telex_release = include_telex_release;
    },

    setIncludeOtherServices(state, include_other_services) {
        state.request.include_other_services = include_other_services;
    },

    setOtherServices(state, other_services) {
        state.request.other_services = other_services;
    },

    setIncludeLetterOfCreditHandling(state, include_letter_of_credit_handling) {
        state.request.include_letter_of_credit_handling = include_letter_of_credit_handling;
    },

    setFileAttachments(state, file_attachments) {
        state.request.file_attachments = file_attachments;
    }
};

const getters = {};

const actions = {};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};

// VUEX store variables for newQuotation

// newQuotationRequest: {
//   get() {
//     return this.$store.state.newQuotation.request
//   }
// },

// step: {
//   get() {
//     return this.$store.state.newQuotation.step
//   },
//   set(value) {
//     this.$store.commit("newQuotation/setStep", value)
//   }
// },

// company_id: {
//   get() {
//     return this.$store.state.newQuotation.request.company_id
//   },
//   set(value) {
//     this.$store.commit("newQuotation/setCompanyID", value)
//   }
// },

// currency: {
//   get() {
//     return this.$store.state.newQuotation.request.currency
//   },
//   set(value) {
//     this.$store.commit("newQuotation/setCurrency", value)
//   }
// },

// hs_code: {
//   get() {
//     return this.$store.state.newQuotation.request.hs_code
//   },
//   set(value) {
//     this.$store.commit("newQuotation/setHSCode", value)
//   }
// },

// transaction_type: {
//   get() {
//     return this.$store.state.newQuotation.request.transaction_type
//   },
//   set(value) {
//     this.$store.commit("newQuotation/setTransactionType", value)
//   }
// },

// quotation_type: {
//   get() {
//     return this.$store.state.newQuotation.request.quotation_type
//   },
//   set(value) {
//     this.$store.commit("newQuotation/setQuotationType", value)
//   }
// },

// incoterm: {
//   get() {
//     return this.$store.state.newQuotation.request.incoterm
//   },
//   set(value) {
//     this.$store.commit("newQuotation/setIncoterm", value)
//   }
// },

// origin_port: {
//   get() {
//     return this.$store.state.newQuotation.request.origin_port
//   },
//   set(value) {
//     this.$store.commit("newQuotation/setOriginPort", value)
//   }
// },

// destination_port: {
//   get() {
//     return this.$store.state.newQuotation.request.destination_port
//   },
//   set(value) {
//     this.$store.commit("newQuotation/setDestinationPort", value)
//   }
// },

// cargo_ready_date: {
//   get() {
//     return this.$store.state.newQuotation.request.cargo_ready_date
//   },
//   set(value) {
//     this.$store.commit("newQuotation/setCargoReadyDate", value)
//   }
// },

// cargo_type: {
//   get() {
//     return this.$store.state.newQuotation.request.cargo_type
//   },
//   set(value) {
//     this.$store.commit("newQuotation/setCargoType", value)
//   }
// },

// commodity: {
//   get() {
//     return this.$store.state.newQuotation.request.commodity
//   },
//   set(value) {
//     this.$store.commit("newQuotation/setCommodity", value)
//   }
// },

// container_type: {
//   get() {
//     return this.$store.state.newQuotation.request.container_type
//   },
//   set(value) {
//     this.$store.commit("newQuotation/setContainerType", value)
//   }
// },

// container_size: {
//   get() {
//     return this.$store.state.newQuotation.request.container_size
//   },
//   set(value) {
//     this.$store.commit("newQuotation/setContainerSize", value)
//   }
// },

// container_quantity: {
//   get() {
//     return this.$store.state.newQuotation.request.container_quantity
//   },
//   set(value) {
//     this.$store.commit("newQuotation/setContainerQuantity", value)
//   }
// },

// packing_quantity: {
//   get() {
//     return this.$store.state.newQuotation.request.packing_quantity
//   },
//   set(value) {
//     this.$store.commit("newQuotation/setPackingQuantity", value)
//   }
// },

// packing_type: {
//   get() {
//     return this.$store.state.newQuotation.request.packing_type
//   },
//   set(value) {
//     this.$store.commit("newQuotation/setPackingType", value)
//   }
// },

// total_weight: {
//   get() {
//     return this.$store.state.newQuotation.request.total_weight
//   },
//   set(value) {
//     this.$store.commit("newQuotation/setTotalWeight", value)
//   }
// },

// weight_unit: {
//   get() {
//     return this.$store.state.newQuotation.request.weight_unit
//   },
//   set(value) {
//     this.$store.commit("newQuotation/setWeightUnit", value)
//   }
// },

// total_cubic_meters: {
//   get() {
//     return this.$store.state.newQuotation.request.total_cubic_meters
//   },
//   set(value) {
//     this.$store.commit("newQuotation/setTotalCubicMeters", value)
//   }
// },

// cargo_units: {
//   get() {
//     return this.$store.state.newQuotation.request.cargo_units
//   },
//   set(value) {
//     this.$store.commit("newQuotation/setCargoUnits", value)
//   }
// },

// include_customs_clearance_export: {
//   get() {
//     return this.$store.state.newQuotation.request
//       .include_customs_clearance_export
//   },
//   set(value) {
//     this.$store.commit(
//       "newQuotation/setIncludeExportCustomsClearance",
//       value
//     )
//   }
// },

// include_customs_clearance_import: {
//   get() {
//     return this.$store.state.newQuotation.request
//       .include_customs_clearance_import
//   },
//   set(value) {
//     this.$store.commit(
//       "newQuotation/setIncludeImportCustomsClearance",
//       value
//     )
//   }
// },

// include_insurance: {
//   get() {
//     return this.$store.state.newQuotation.request.include_insurance
//   },
//   set(value) {
//     this.$store.commit("newQuotation/setIncludeInsurance", value)
//   }
// },

// cargo_value_currency: {
//   get() {
//     return this.$store.state.newQuotation.request.cargo_value_currency
//   },
//   set(value) {
//     this.$store.commit("newQuotation/setCargoValueCurrency", value)
//   }
// },

// cargo_value: {
//   get() {
//     return this.$store.state.newQuotation.request.cargo_value
//   },
//   set(value) {
//     this.$store.commit("newQuotation/setCargoValue", value)
//   }
// },

// include_haulage_export: {
//   get() {
//     return this.$store.state.newQuotation.request.include_haulage_export
//   },
//   set(value) {
//     this.$store.commit("newQuotation/setIncludeHaulageExport", value)
//   }
// },

// include_haulage_sdl_export: {
//   get() {
//     return this.$store.state.newQuotation.request.include_haulage_sdl_export
//   },
//   set(value) {
//     this.$store.commit("newQuotation/setIncludeHaulageSDLExport", value)
//   }
// },

// city_haulage_export: {
//   get() {
//     return this.$store.state.newQuotation.request.city_haulage_export
//   },
//   set(value) {
//     this.$store.commit("newQuotation/setCityHaulageExport", value)
//   }
// },

// include_haulage_import: {
//   get() {
//     return this.$store.state.newQuotation.request.include_haulage_import
//   },
//   set(value) {
//     this.$store.commit("newQuotation/setIncludeHaulageImport", value)
//   }
// },

// include_haulage_sdl_import: {
//   get() {
//     return this.$store.state.newQuotation.request.include_haulage_sdl_import
//   },
//   set(value) {
//     this.$store.commit("newQuotation/setIncludeHaulageSDLImport", value)
//   }
// },

// city_haulage_import: {
//   get() {
//     return this.$store.state.newQuotation.request.city_haulage_import
//   },
//   set(value) {
//     this.$store.commit("newQuotation/setCityHaulageImport", value)
//   }
// },

// include_transport_export: {
//   get() {
//     return this.$store.state.newQuotation.request.include_transport_export
//   },
//   set(value) {
//     this.$store.commit("newQuotation/setIncludeTransportExport", value)
//   }
// },

// city_transport_export: {
//   get() {
//     return this.$store.state.newQuotation.request.city_transport_export
//   },
//   set(value) {
//     this.$store.commit("newQuotation/setCityTransportExport", value)
//   }
// },

// include_transport_import: {
//   get() {
//     return this.$store.state.newQuotation.request.include_transport_import
//   },
//   set(value) {
//     this.$store.commit("newQuotation/setIncludeTransportImport", value)
//   }
// },

// city_transport_import: {
//   get() {
//     return this.$store.state.newQuotation.request.city_transport_import
//   },
//   set(value) {
//     this.$store.commit("newQuotation/setCityTransportImport", value)
//   }
// },

// include_telex_release: {
//   get() {
//     return this.$store.state.newQuotation.request.include_telex_release
//   },
//   set(value) {
//     this.$store.commit("newQuotation/setIncludeTelexRelease", value)
//   }
// },

// include_letter_of_credit_handling: {
//   get() {
//     return this.$store.state.newQuotation.request
//       .include_letter_of_credit_handling
//   },
//   set(value) {
//     this.$store.commit(
//       "newQuotation/setIncludeLetterOfCreditHandling",
//       value
//     )
//   }
// },

// include_other_services: {
//   get() {
//     return this.$store.state.newQuotation.request.include_other_services
//   },
//   set(value) {
//     this.$store.commit("newQuotation/setIncludeOtherServices", value)
//   }
// },

// other_services: {
//   get() {
//     return this.$store.state.newQuotation.request.other_services
//   },
//   set(value) {
//     this.$store.commit("newQuotation/setOtherServices", value)
//   }
// }